import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { Modal, ModalActions } from '../../../components/Modal'
import { InboxType } from '../../../../server/models/Inbox'
import { deleteInboxMember } from '../../../requests/inboxMembers'
import { handleError } from '../../../errors/handleError'

type Props = {
  onClose: () => void
  inboxToLeave: InboxType
  onLeftInbox: (inboxDeleted: InboxType) => void
}

export const LeaveInboxModal: React.FC<Props> = ({ onClose, inboxToLeave, onLeftInbox }) => {
  const [deleting, setDeleting] = useState(false)

  const closeModal = () => {
    onClose()
  }

  const onLeaveInbox = async () => {
    setDeleting(true)
    try {
      await deleteInboxMember(inboxToLeave._id, 'me')
      onLeftInbox(inboxToLeave)
      setDeleting(false)
      closeModal()
      toast.success('Folder removed.')
    } catch (err) {
      handleError(err, 'Something went wrong removing this folder. Please try again.')
      setDeleting(false)
      onClose()
    }
  }

  return (
    <Modal isOpen={!!inboxToLeave} onRequestClose={closeModal}>
      <h2>Are you sure you want to remove {`"${inboxToLeave?.name}"`}?</h2>
      <p>
          This action cannot be undone.
      </p>
      <ModalActions
        onCancel={closeModal}
        onSubmit={onLeaveInbox}
        loading={deleting}
        submitText="Remove"
      />
    </Modal>
  )
}

